import { render, staticRenderFns } from "./IndustrySectorForm.vue?vue&type=template&id=d3560ff6&scoped=true"
import script from "./IndustrySectorForm.vue?vue&type=script&lang=js"
export * from "./IndustrySectorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3560ff6",
  null
  
)

export default component.exports